import { ApiResponse } from "../types";
import { ImportAttributes } from "../types";
import { apiClient } from "./apiClient";

const BASE = "/imports";

function buildUrl(
  path: string,
  params?: Record<string, string | number>
): string {
  if (!params || Object.keys(params).length === 0) return path;
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => search.set(k, String(v)));
  return `${path}?${search.toString()}`;
}

export const importsApi = {
  async getAll(companyId?: number): Promise<ApiResponse<ImportAttributes[]>> {
    try {
      const url = companyId != null ? buildUrl(BASE, { companyId }) : BASE;
      const data = await apiClient.get<any>(url);
      return {
        success: true,
        data: Array.isArray(data)
          ? data
          : (data?.data ?? data?.imports ?? []),
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },

  /**
   * Delete transactions for an import (only for type "transaction").
   * DELETE /imports/:id/transactions
   * Response: { message, data: { deleted: number } }
   */
  async deleteTransactions(id: number): Promise<ApiResponse<{ deleted: number }>> {
    try {
      const data = await apiClient.delete<any>(`/imports/${id}/transactions`);
      return {
        success: true,
        data: data?.data ?? { deleted: 0 },
      };
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
      };
    }
  },
};
